export default function EasySetup() {
  const points = [
    'No new apps for customers',
    'No website redesign',
    'No complicated software',
    'Setup typically takes 1–3 days'
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12">
          No Changes To How You Work
        </h2>

        <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          {points.map((point, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
              <p className="text-lg text-gray-900">
                {point}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
